// extracted by mini-css-extract-plugin
module.exports = {"historySection":"historySection_historySection__Kxa55","historySection__title":"historySection_historySection__title__tMuXX"};